import { Tooltip as MuiTooltip, Typography } from '@mui/material';
import './Tooltip.css';
export enum TooltipPlacement {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
  BOTTOM_END = 'bottom-end',
  BOTTOM_START = 'bottom-start',
  LEFT_END = 'left-end',
  LEFT_START = 'left-start',
  RIGHT_END = 'right-end',
  RIGHT_START = 'right-start',
  TOP_END = 'top-end',
  TOP_START = 'top-start',
}

interface TooltipProps {
  children: React.ReactElement;
  title: string | React.ReactNode;
  placement?: TooltipPlacement;
  arrow?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ title, children, placement, arrow, ...rest }) => {
  return (
    <MuiTooltip
      arrow
      placement={placement}
      className='EQXXI-TooltipComponent'
      title={
        <Typography>
          {title}
        </Typography>
      }
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
